<template>
  <div class="practicalAssessment">
    <div class="practicalAssessment-box">
      <div class="search">
        <el-form
          ref="search"
          :inline="true"
          :model="condition"
          :rules="rules"
          label-width="80px"
          style="display: flex; justify-content: space-between"
        >
          <div>
            <!-- <el-form-item prop="identity">
                <el-input v-model="condition.identity" placeholder="请输入身份证" clearable></el-input>
            </el-form-item> -->
            <!-- <el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>
            </el-form-item> -->
            <el-form-item v-if="isShowPrac">
              <el-button type="primary" @click="applicationClick('prac')">实践考核报名</el-button>
            </el-form-item>
            <el-form-item v-if="isShowDesign">
              <el-button type="primary" @click="applicationClick('design')">毕业设计（论文）报名</el-button>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" @click="exit">退出登录</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!-- v-if="isShowTable" -->
      <el-table
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        :data="tableData"
        border
        style="width: 100%;margin-top: 20px;"
      >
        <el-table-column prop="student_title" align="center" label="学生姓名"></el-table-column>
        <el-table-column prop="exam_number" align="center" label="准考证号"></el-table-column>
        <el-table-column prop="prac_title" align="center" label="考核计划名称"></el-table-column>
        <el-table-column prop="course_type" align="center" label="考核类型">
          <template slot-scope="{row}">
            <span v-if="row.course_type == 3">实践考核</span>
            <span v-else-if="row.course_type == 4">毕业设计（论文）</span>
          </template>
        </el-table-column>
        <el-table-column prop="profession_title" align="center" label="专业名称"></el-table-column>
        <el-table-column prop="course_title" align="center" label="课程名称"></el-table-column>
        <el-table-column prop="course_code" align="center" label="课程代码"></el-table-column>
        <el-table-column prop="reg_fee" align="center" label="报名费"></el-table-column>
        <el-table-column prop="is_pay" align="center" label="是否缴费">
          <template slot-scope="{row}">
            <span v-if="row.is_pay == 1">已缴费</span>
            <span v-else>未缴费</span>
          </template>
        </el-table-column>
        <el-table-column prop="pay_time" align="center" label="缴费时间"></el-table-column>
        <el-table-column prop="score" align="center" label="考核成绩"></el-table-column>
        <el-table-column prop="created_at" align="center" label="报名时间"></el-table-column>
        <el-table-column align="center" label="操作" min-width="120">
          <template slot-scope="{row}">
            <el-button :disabled="row.is_one === 1" class="link-btn" type="text" @click="designDataClickPer(row, 1)">
              一稿上传
            </el-button>
            <el-button :disabled="row.is_two === 1" class="link-btn" type="text" @click="designDataClickPer(row, 2)">
              二稿上传
            </el-button>
            <el-button :disabled="row.is_three === 1" class="link-btn" type="text" @click="designDataClickPer(row, 3)">
              三稿上传
            </el-button>
            <el-button class="link-btn" type="text" @click="duplicateCheck(row)">
              去查重
            </el-button>
            <el-button @click="delFun(row)" type="text" style="color: #e85f64">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 实践考核报名 -->
    <el-dialog
      class="application-pop"
      title="实践考核报名"
      :visible.sync="isShowApplicationPop"
      width="30%"
      @close="applicationClose"
    >
      <div class="dialog">
        <el-form
          ref="application"
          :model="applicationData"
          :rules="applicationRules"
          label-width="80px"
        >
          <el-form-item label="专业" prop="profession_id">
            <el-select v-model="applicationData.profession_id" placeholder="请选择专业" clearable filterable
                       style="width: 100%;" @change="professionChange">
              <el-option v-for="item in professionList" :key="item.id" :label="item.profession_title"
                         :value="item.profession_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程" prop="prac_course_id">
            <el-select v-model="applicationData.prac_course_id" placeholder="请选择课程" multiple clearable filterable
                       style="width: 100%;">
              <el-option v-for="item in pracProCourseList" :key="item.id" :label="item.course_title"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center">
        <el-button @click="isShowApplicationPop = false">取 消</el-button>
        <el-button type="primary" @click="applicationSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 一稿上传/二稿上传/三稿上传 -->
    <el-dialog
      class="designData"
      :title="(designType == 1 && '一稿上传') || (designType == 2 && '二稿上传') || (designType == 3 && '三稿上传')"
      :visible.sync="isShowDesignData"
      width="40%"
      @close="designDataClosePer"
    >
      <div class="dialog">
        <el-form
          ref="designDataRefPer"
          :model="designDataData"
          :rules="designDataRules"
          label-width="200px"
        >
          <el-form-item label="设计资料文件:" prop="files_url">
            <FalConUpload
              ref="designDataUploadFile"
              listStyle='text'
              accept=".pdf,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx"
              :limit='20'
              :multiple="true"
              :isFile="true"
              :isAccept="false"
              @handleRemove="handleRemoveFilePer"
              @handleChange="handleChangeFilePer"
            >
            </FalConUpload>
            <div class="tips">说明：可上传PDF文档，压缩文件或OFFICE文档</div>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center">
        <el-button @click="isShowDesignData = false">取 消</el-button>
        <el-button type="primary" @click="designDataSubmitPer">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  pracGetSign,
  pracGet,
  pracGetProfession,
  pracGetProCourse,
  pracSubmitSign,
  designGet,
  pracDelSign,
  pracPostDeSign,
} from "@/api/practicalAssessment";

import {putObject, uploadFiles, deleteObject} from "@/utils/upload";
import {arrAttDel, deepClone, goFirstError} from '@/utils/func';

import {downladUrl} from '@/utils/func';

import FalConUpload from "@/components/uploadFile";

export default {
  name: 'practicalAssessment',
  components: {FalConUpload},
  filters: {},
  data() {
    return {
      isShowPrac: true,  //显示实践考核报名按钮
      isShowDesign: true,  //显示毕业设计报名按钮
      tableData: [],
      isShowTable: false,
      condition: {
        // student_code: '',  //学号
        // identity: '', //身份证
        // candidate_number: '',  //考生号
      },
      rules: {
        identity: [{required: true, message: '请输入身份证', trigger: 'blur'}],
      },
      pracData: null,  //考核数据
      designData: null,  //毕业设计数据
      //保存点击报名的数据
      seleteData: {
        id: null,
        type: null,
        name: '',
      },
      professionList: [],  //考核报名专业
      pracProCourseList: [],  //考核报名课程
      // 弹窗
      isShowApplicationPop: false,
      applicationData: {
        prac_id: '',  //考核计划id
        profession_id: '',  //专业id
        prac_course_id: [],  //课程id
      },
      applicationRules: {
        profession_id: [{required: true, message: '请选择专业', trigger: 'change'}],
        prac_course_id: [{required: true, message: '请选择课程', trigger: 'change'}],
      },

      designType: 1,  //一二三搞上传类型
      // 一二三搞上传
      isShowDesignData: false,
      designDataData: {
        id: '',  //论文计划学生ids
        files_url: '',  //任务书及开题报告文件/设计资料文件
        // imgs_url: '',  //任务书及开题报告图片/设计资料图片
        // sign_img: '',  //手写签名图片地址
        num: '',  //类型 一二三搞
      },
      designDataRules: {
        files_url: [{required: true, message: '请上传设计资料文件', trigger: 'change'}],
        // imgs_url: [{ required: true, message: '请上传设计资料图片', trigger: 'change' }],
        // sign_img: [{ required: true, message: '请添加手写签名', trigger: 'change' }],
      },
    };
  },
  created() {
    this.getdata();
    this.getPracGet();
    this.getDesignGet();
    // this.getProfession();
  },
  methods: {
    // 点击去查重
    duplicateCheck(row){
      this.$router.push({
        name: "duplicate",
        query: {
          id: row.id,
        },
      });
    },
    // 一二三稿上传 提交
    designDataSubmitPer() {
      this.$refs["designDataRefPer"].validate((valid) => {
        if (valid) {
          uploadFiles(this.designDataData.files_url, (urls) => {
            let data = deepClone(this.designDataData);
            data.files_url = urls;
            pracPostDeSign(data).then(res => {
              if (res.code == 200) {
                this.$message.success('保存成功');
                this.isShowDesignData = false;
                this.getPracGet();
              }
            });
          }, null, 'student', '', true);
        }
      })
    },
    // 弹窗 一二三稿上传 关闭
    designDataClosePer() {
      this.openingReportData = {
        paper_plan_student_id: '',  //论文计划学生id
        files_url: '',  //任务书及开题报告文件/设计资料文件
        // imgs_url: '',  //任务书及开题报告图片/设计资料图片
        // sign_img: '',  //手写签名图片地址
        num: '',  //类型 一二三搞
      };
      this.$refs['designDataUploadFile'].reset();
      // if (this.$refs['esignHandleDesignData']) {
      //   this.$refs['esignHandleDesignData'].handleReset();  //签名这块清空
      // }
      this.$nextTick(() => {
        this.$refs['designDataRefPer'].clearValidate();
      });
    },
    // 上传 一二三稿上传
    handleChangeFilePer(data) {
      this.designDataData.files_url = data.fileList;
      this.$refs['designDataRefPer'].validateField('files_url');
    },
    //  删除 一二三稿上传
    handleRemoveFilePer(data) {
      this.designDataData.files_url = data.fileList;
    },
    // 一二三稿上传
    designDataClickPer(row, num) {
      this.designDataData.id = row.id;
      this.designDataData.num = num;
      this.designType = num;
      this.isShowDesignData = true;
    },
    // 删除
    delFun(row) {
      this.$confirm("此操作将删除此条数据, 是否确认?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        pracDelSign({
          id: row.id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.loadData();
          }
        });
      });
    },
    // 退出
    async exit() {
      // loginOut(null).then(() => {
      // this.$store.dispatch('permission/setIsGenerateRoutes', '');
      await this.$store.dispatch('permission/logOut');
      // Cookies.remove('token');
      this.$message.success('退出成功');
      this.$router.replace("/Login");

      // });
    },
    // 实践考核报名 提交
    applicationSubmit() {
      this.$refs["application"].validate((valid) => {
        if (valid) {
          const data = {
            prac_id: this.applicationData.prac_id,
            profession_id: this.applicationData.profession_id,
            prac_course_id: this.applicationData.prac_course_id.toString(),
          };
          pracSubmitSign(data).then(res => {
            this.$message.success('操作成功');
            this.isShowApplicationPop = false;
            this.getdata();
          });
        }
      });
    },
    // 点击报名
    applicationClick(name) {
      this.isShowApplicationPop = true;
      this.seleteData.name = name;
      if (name === 'prac') {
        this.seleteData.id = this.pracData.id;
        this.seleteData.type = 3;
      } else if (name === 'design') {
        this.seleteData.id = this.designData.id;
        this.seleteData.type = 4;
      }
      this.applicationData.prac_id = this.seleteData.id;
    },
    // 弹窗 关闭
    applicationClose() {
      this.applicationData.profession_id = '';
      this.applicationData.prac_course_id = '';
      this.pracProCourseList = [];
      this.$nextTick(() => {
        this.$refs["application"].clearValidate();
      });
    },
    // 选择专业
    professionChange(v) {
      this.applicationData.prac_course_id = '';
      if (v == '') {
        this.pracProCourseList = [];
        return;
      }
      this.getProCourse(this.seleteData.type, v);
    },
    loadData() {
      this.$refs['search'].validate((valid) => {
        if (valid) {
          this.getdata();
        }
      });
    },
    // 获取实践考核数据
    getPracGet() {
      pracGet().then(res => {
        if (res.code == 200) {
          if (res.result) {
            this.isShowPrac = true;
            this.pracData = res.result;
            if (this.professionList.length <= 0) {
              this.getProfession();
            }
          } else {
            this.isShowPrac = false;
          }
        }
      });
    },
    // 获取毕业设计数据
    getDesignGet() {
      designGet().then(res => {
        if (res.code == 200) {
          if (res.result) {
            this.isShowDesign = true;
            this.designData = res.result;
            if (this.professionList.length <= 0) {
              this.getProfession();
            }
          } else {
            this.isShowDesign = false;
          }
        }
      });
    },
    getdata() {
      let data = this.condition;
      pracGetSign(data).then(res => {
        if (res.code == 200) {
          this.tableData = res.result;
          // this.isShowTable = true;
        }
      });
    },
    // 获取专业
    getProfession() {
      pracGetProfession().then(res => {
        if (res.code == 200) {
          this.professionList = res.result;
        }
      });
    },
    // 获取课程
    getProCourse(type, profession_id) {
      const data = {
        type,
        profession_id,
      };
      pracGetProCourse(data).then(res => {
        if (res.code == 200) {
          this.pracProCourseList = res.result;
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.practicalAssessment {
  padding: 20px;
  height: 100vh;
  overflow-y: auto;

  .practicalAssessment-box {
    background-color: #fff;
    padding: 20px;
  }
}
</style>
